import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { PublicToolbarComponent } from './components/public-toolbar/public-toolbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoadingComponent } from './components/loading/loading.component';
import { GenericDialogComponent } from './components/generic-dialog/generic-dialog.component';
import { EmptyPageComponent } from './components/empty-page/empty-page.component';
import { RouterModule } from '@angular/router';
import { CrowdCardComponent } from './components/crowd-card/crowd-card.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MoneyComponent } from '../modules/platform/components/money/money.component';
import { DialogCashoutComponent } from '../modules/platform/pages/dashboard/components/dialog-cashout/dialog-cashout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslationModule } from '../modules/i18n';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgPipesModule } from 'ngx-pipes';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AlertCardComponent } from '../modules/platform/pages/dashboard/components/alert-card/alert-card.component';
import { PlaceholderComponent } from './components/placeholder/placeholder.component';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    TranslationModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    NgPipesModule,
    CarouselModule
  ],
  exports: [
    MaterialModule,
    PublicToolbarComponent,
    FooterComponent,
    MoneyComponent,
    LoadingComponent,
    EmptyPageComponent,
    MatDatepickerModule,
    CrowdCardComponent,
    DialogCashoutComponent,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    NgPipesModule,
    CarouselModule,
    AlertCardComponent,
    PlaceholderComponent
  ],
  declarations: [
    MoneyComponent,
    PublicToolbarComponent,
    FooterComponent,
    LoadingComponent,
    GenericDialogComponent,
    EmptyPageComponent,
    CrowdCardComponent,
    DialogCashoutComponent,
    AlertCardComponent,
    PlaceholderComponent
  ],
})
export class SharedModule {}
